import { Template } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface DisplayWebContentTemplateRequiredRuleDto {
  template: Template;
}

export const DisplayWebContentTemplateRequiredRuleKey = 'displayWebContentTemplateRequired';

/**
 * A template needs to be chosen if a `Display web content` message is added to the workflow.
 *
 * @param template
 * @returns 'fail', with an error message, if no template is chosen. 'pass' if a template is chosen.
 */
export const DisplayWebContentTemplateRequiredRule = (dto: DisplayWebContentTemplateRequiredRuleDto): DomainRule => {
  if (!dto.template?.id) {
    return {
      result: 'fail',
      ruleKey: DisplayWebContentTemplateRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
